export default "__VITE_ASSET__566904a2__"